import { ChangeEvent } from 'react';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import FormTextBox from './FormTextBox';

/**Masked text input */
export function FormMaskedText(props: ICommonFormProps) {
    const { formProps, register, keyName, registerOptions, inputProperties } = props;
    const registerProps = register(keyName, registerOptions);

    return (
        <FormTextBox
            {...props}
            register={undefined!}
            inputProperties={{
                ...inputProperties,
                ...registerProps,
                onChange: (e: ChangeEvent<HTMLInputElement>) => {
                    if (formProps?.maskOnChange) {
                        e.target.value = formProps?.maskOnChange(e.target.value);
                    }
                    registerProps.onChange(e);
                },
            }}
        />
    );
}
